import { User } from "src/lib/endpoints/auth/auth.type";

export const getPaginationData = (structure: any) => {
  const { total_records, records_per_page } = structure;
  const total_pages = Math.ceil(total_records / records_per_page);
  const pages = [];
  for (let i = 1; i <= total_pages; i++) {
    pages.push(i);
  }
  return { total_pages, pages };
};

export const startCase = (word: string) => {
  return word?.charAt(0).toUpperCase() + word?.slice(1).toLowerCase();
};

export const getOrdinalSuffix = (num: number) => {
  if (num % 100 >= 11 && num % 100 <= 13) {
    return `${num}th`;
  }

  switch (num % 10) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};

export const shareOnTwitter = (message: string) => {
  const hashtags = "droomwork,talents,client";
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    message
  )}&hashtags=${hashtags}`;
  // &url=${encodeURIComponent(refUrl)}
  window.open(twitterUrl, "_blank");
};

export const shareOnWhatsapp = (message: string, tags: string) => {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
    message + tags
  )}`;

  window.open(whatsappUrl, "_blank");
};

export const shareOnLinkedIn = (
  message: string,
  tags: string,
  refUrl: string
) => {
  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?text=${encodeURIComponent(
    message + tags
  )}&url=${encodeURIComponent(refUrl)}`;
  window.open(linkedinShareUrl, "_blank");
};

export const shareOnFacebook = (message: string, refUrl: string) => {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    refUrl + "\n\n" + message
  )}`;
  window.open(facebookShareUrl, "_blank", "noopener,noreferrer");
};




export const extractAddress = (
  location: User['userLocation'] | undefined
) => {
  if (!location) return "Nil";

  const parts = [
    location.street_number,
    location.street_name,
    // location.city,
    location.state,
    location.country,
  ].filter(Boolean);

  return parts.join(", ");
};

export const countryToContinent = (country: string) => {
  const map: Record<string, string> = {
    Nigeria: "Africa",
    Ghana: "Africa",
    Kenya: "Africa",

    UnitedStates: "North America",
    "United States": "North America",

    UK: "Europe",
    "United Kingdom": "Europe",

    France: "Europe",
    Germany: "Europe"
  };

  return map[country] || "";
};